import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';

import { F8916Component } from './components/f8916/f8916.component';
import { F8916LimComponent } from './components/f8916-lim/f8916-lim.component';
import { F7004Component } from './components/f7004/f7004.component';
import { F3800PIIIConsolComponent } from './components/f3800-piii-consol/f3800-piii-consol.component';
import { F1125SchEComponent } from './components/f1125-sch-e/f1125-sch-e.component';
import { F1125SchAComponent } from './components/f1125-sch-a/f1125-sch-a.component';
import { F1120SchNComponent } from './components/f1120-sch-n/f1120-sch-n.component';
import { F1120SchKComponent } from './components/f1120-sch-k/f1120-sch-k.component';
import { F1120SchBComponent } from './components/f1120-sch-b/f1120-sch-b.component';
import { F1120SchM3Component } from './components/f1120-sch-m3/f1120-sch-m3.component';
import { LimitToMaxDirective } from './directives/limit-to-max.directive';
import { F1120SchM2Component } from './components/f1120-sch-m2/f1120-sch-m2.component';
import { F1120SchM2RetainedEarningsComponent } from './components/f1120-sch-m2-retained-earnings/f1120-sch-m2-retained-earnings.component';
import { F1120SubconsolComponent } from './components/f1120-subconsol/f1120-subconsol.component';
import { F163jReclassTriggerComponent } from './components/f163j-reclass-trigger/f163j-reclass-trigger.component';
import { F163jAutoEpComponent } from './components/f163j-auto-ep/f163j-auto-ep.component';
import { F163jSchdADataRefreshComponent } from './components/f163j-schd-a-data-refresh/f163j-schd-a-data-refresh.component';
import { AllocBatchRerunComponent } from './components/alloc-batch-rerun/alloc-batch-rerun.component';
import { F1120SchJComponent } from './components/f1120-sch-j/f1120-sch-j.component';
import { F1120pcSchEComponent } from './components/f1120pc-sch-e/f1120pc-sch-e.component';
import { F1120pcSchFComponent } from './components/f1120pc-sch-f/f1120pc-sch-f.component';
import { F1120lSchAComponent } from './components/f1120l-sch-a/f1120l-sch-a.component';
import { F1120lSchBComponent } from './components/f1120l-sch-b/f1120l-sch-b.component';
import { F1120lSchFComponent } from './components/f1120l-sch-f/f1120l-sch-f.component';
import { F1120lSchLComponent } from './components/f1120l-sch-l/f1120l-sch-l.component';
import { F1120lSchGComponent } from './components/f1120l-sch-g/f1120l-sch-g.component';
import { F1120lSchMComponent } from './components/f1120l-sch-m/f1120l-sch-m.component';
import { F1120pcSchCComponent } from './components/f1120pc-sch-c/f1120pc-sch-c.component';
import { F1120pcSchIComponent } from './components/f1120pc-sch-i/f1120pc-sch-i.component';
import { F1120SchcLine22Component } from './components/f1120-schc-line22/f1120-schc-line22.component';
import { F1120SchcLine22Service } from './components/f1120-schc-line22/f1120-schc-line22.service';
import { FilterPipe } from '../shared/pipes/filter.pipe';

@NgModule({
  declarations: [
    F8916Component,
    F8916LimComponent,
    F7004Component,
    F3800PIIIConsolComponent,
    F1125SchEComponent,
    F1125SchAComponent,
    F1120SchNComponent,
    F1120SchKComponent,
    F1120SchBComponent,
    F1120SchM3Component,
    LimitToMaxDirective,
    F1120SchM2Component,
    F1120SchM2RetainedEarningsComponent,
    F1120SubconsolComponent,
    F163jReclassTriggerComponent,
    F163jAutoEpComponent,
    F163jSchdADataRefreshComponent,
    AllocBatchRerunComponent,
    F1120SchJComponent,
    F1120pcSchEComponent,
    F1120pcSchCComponent,
    F1120pcSchIComponent,
    F1120pcSchFComponent,
    F1120lSchAComponent,
    F1120lSchBComponent,
    F1120lSchFComponent,
    F1120lSchLComponent,
    F1120lSchGComponent,
    F1120lSchMComponent,
    F1120SchcLine22Component,
    FilterPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ],
  exports: [
    F8916Component,
    F8916LimComponent,
    F7004Component,
    F3800PIIIConsolComponent,
    F1125SchEComponent,
    F1125SchAComponent,
    F1120SchNComponent,
    F1120SchKComponent,
    F1120SchBComponent,
    F1120SchM3Component,
    F1120SchM2Component,
    F1120SchM2RetainedEarningsComponent,
    F1120SubconsolComponent,
    F163jReclassTriggerComponent,
    F163jAutoEpComponent,
    F163jSchdADataRefreshComponent,
    AllocBatchRerunComponent,
    F1120SchJComponent,
    F1120pcSchEComponent,
    F1120pcSchCComponent,
    F1120pcSchIComponent,
    F1120pcSchFComponent,
    F1120lSchAComponent,
    F1120lSchBComponent,
    F1120lSchFComponent,
    F1120lSchLComponent,
    F1120lSchGComponent,
    F1120lSchMComponent,
    F1120SchcLine22Component,
    FilterPipe
  ]
})
export class F1120Module { }
